{
  "attorney": {
    "header": {
      "title": "Attorney Dashboard"
    },
    "nav": {
      "filingQueue": "Filing Queue",
      "approvalQueue": "Approval Queue",
      "clients": "My Clients",
      "correspondence": "Correspondence",
      "deadlines": "Deadlines",
      "jurisdictions": "Jurisdictions",
      "assignments": "Manage Assignments",
      "backToDashboard": "Back to Dashboard"
    },
    "filingQueue": {
      "title": "Filing Queue",
      "loading": "Loading filing queue...",
      "error": "Error loading filing queue",
      "empty": "No filings in queue",
      "allCountries": "All Countries",
      "allStatuses": "All Statuses",
      "statusPending": "Pending",
      "statusFiled": "Filed",
      "refresh": "Refresh"
    },
    "filingCard": {
      "allFiled": "All filed",
      "partiallyFiled": "In progress",
      "pending": "Pending",
      "client": "Client",
      "classes": "Classes",
      "country": "Country",
      "status": "Status",
      "ipOfficeRef": "IP Office Ref",
      "actions": "Actions",
      "jurisdictionsFiled": "jurisdictions filed"
    },
    "jurisdiction": {
      "pending": "Pending",
      "filed": "Filed",
      "accepted": "Accepted",
      "registered": "Registered",
      "rejected": "Rejected",
      "fileNow": "File Now",
      "viewDocs": "View Docs",
      "view": "View",
      "editRef": "Edit Ref"
    },
    "fileNowModal": {
      "title": "File in {{country}}",
      "applicationRef": "Application Reference",
      "useReference": "Use this reference in all IP Office forms:",
      "copy": "Copy",
      "copied": "Copied!",
      "ipOfficePortal": "IP Office Portal",
      "openPortal": "Open Portal",
      "instructions": "Instructions",
      "step1": "Log in to {{office}} portal",
      "step2": "Start new trademark application",
      "step3": "Enter \"{{appId}}\" in \"Your Reference\" field",
      "step4": "Upload the generated filing document",
      "step5": "Complete payment on IP Office",
      "step6": "Note the {{office}} reference number",
      "documents": "Documents",
      "afterFiling": "After filing, enter the IP Office reference number:",
      "cancel": "Cancel",
      "markAsFiled": "Mark as Filed",
      "marking": "Marking..."
    },
    "approvalQueue": {
      "title": "Approval Queue",
      "loading": "Loading approval queue...",
      "error": "Error loading approval queue",
      "empty": "No tasks awaiting approval",
      "allTypes": "All Types",
      "officeAction": "Office Action Responses",
      "opposition": "Opposition Responses",
      "renewal": "Renewal Applications",
      "refresh": "Refresh"
    },
    "approvalCard": {
      "officeAction": "Office Action Response",
      "opposition": "Opposition Response",
      "renewal": "Renewal Application",
      "urgent": "Urgent",
      "high": "High",
      "medium": "Medium",
      "low": "Low",
      "successLikelihood": "Success Likelihood",
      "noSummary": "No summary available",
      "daysLeft": "{{days}} days left",
      "overdue": "Overdue!",
      "review": "Review Draft"
    },
    "draftReview": {
      "title": "Review AI Draft",
      "summary": "Summary",
      "estimatedSuccess": "Estimated Success",
      "keyArguments": "Key Arguments",
      "similarCases": "Similar Cases Referenced",
      "draftContent": "Draft Content",
      "view": "View",
      "edit": "Edit",
      "editPlaceholder": "Edit the draft...",
      "rejectReason": "Reason for Rejection",
      "rejectPlaceholder": "Explain why this draft is being rejected...",
      "back": "Back",
      "reject": "Reject",
      "confirmReject": "Confirm Rejection",
      "rejecting": "Rejecting...",
      "approve": "Approve",
      "approveWithChanges": "Approve with Changes",
      "approving": "Approving..."
    },
    "correspondence": {
      "title": "Correspondence",
      "loading": "Loading correspondence...",
      "error": "Failed to load correspondence",
      "retry": "Retry",
      "refresh": "Refresh",
      "empty": "No correspondence found",
      "emptyHint": "Correspondence will appear here when emails are synced from the docketing mailbox.",
      "filter": {
        "all": "All",
        "unprocessed": "Unprocessed",
        "needsMatching": "Needs Matching",
        "processed": "Processed"
      },
      "types": {
        "officeAction": "Office Action",
        "acceptance": "Acceptance",
        "opposition": "Opposition",
        "renewal": "Renewal Notice",
        "registration": "Registration",
        "general": "General"
      },
      "notLinked": "Not linked to application",
      "from": "From",
      "received": "Received",
      "classification": "Classification",
      "jurisdiction": "Jurisdiction",
      "application": "Application",
      "summary": "Summary",
      "body": "Email Body",
      "manualMatch": "Manual Match",
      "linkToApplication": "Link to Application",
      "markProcessed": "Mark as Processed",
      "processing": "Processing..."
    },
    "manualMatch": {
      "title": "Manual Match",
      "selectApplication": "Select Application",
      "searchPlaceholder": "Search by application ID or trademark name...",
      "searching": "Searching...",
      "or": "or enter manually",
      "change": "Change",
      "classificationDetails": "Classification & Details",
      "classification": "Classification",
      "subType": "Sub-Type",
      "selectSubType": "Select sub-type...",
      "notApplicable": "N/A",
      "jurisdiction": "Jurisdiction",
      "selectJurisdiction": "Select jurisdiction...",
      "deadline": "Deadline",
      "ipOfficeRef": "IP Office Reference",
      "ipOfficeRefPlaceholder": "e.g., TM2025/12345",
      "aiLearning": "AI Learning Feedback",
      "aiLearningDesc": "Help the AI learn from this correction to improve future matching.",
      "whyFailed": "Why did automatic matching fail?",
      "selectFailure": "Select a reason...",
      "whereFound": "Where did you find the correct information?",
      "notes": "Notes (optional)",
      "notesPlaceholder": "Any additional context that might help the AI...",
      "cancel": "Cancel",
      "saveMatch": "Save Match",
      "saving": "Saving...",
      "failures": {
        "unusualFormat": "Unusual Email Format",
        "newIpOffice": "New IP Office Format",
        "pdfFailed": "PDF Extraction Failed",
        "noReference": "No Reference Found",
        "ambiguous": "Ambiguous Reference",
        "inAttachment": "Reference in Attachment Only",
        "newSender": "New Sender/Domain",
        "other": "Other"
      },
      "locations": {
        "subjectLine": "Subject Line",
        "emailBody": "Email Body",
        "pdfAttachment": "PDF Attachment",
        "imageAttachment": "Image Attachment",
        "senderDomain": "Sender Domain"
      },
      "errors": {
        "applicationRequired": "Please select an application",
        "saveFailed": "Failed to save manual match. Please try again."
      }
    }
  }
}
